import { render, staticRenderFns } from "./ComponentConteudoContato.vue?vue&type=template&id=8f2bd1e8&scoped=true&"
import script from "./ComponentConteudoContato.vue?vue&type=script&lang=js&"
export * from "./ComponentConteudoContato.vue?vue&type=script&lang=js&"
import style0 from "./ComponentConteudoContato.vue?vue&type=style&index=0&id=8f2bd1e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2bd1e8",
  null
  
)

export default component.exports